<template>
  <div class="patient-labels">
    <img
      src="@/assets/img/black-list.svg"
      v-bind:alt="$options.titleBlackList"
      v-bind:title="$options.titleBlackList"
      v-if="inBlackList" />
    <img
      src="@/assets/img/mad.svg"
      v-bind:alt="$options.titleUnwanted"
      v-bind:title="$options.titleUnwanted"
      v-if="isUnwanted" />
    <img
      src="@/assets/img/dont-call.svg"
      v-bind:alt="$options.titleNotCall"
      v-bind:title="$options.titleNotCall"
      v-if="isNotCall" />
    <div
      class="patient-labels__item"
      v-bind:key="id"
      v-for="{ id, name } in labelList">{{ name.toLowerCase() }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    /**
     * @description Пациент в черном списке.
     * @type {boolean}
     */
    inBlackList: ({ labels }) => !!labels.find((item) => item.id === 'black-list'),
    /**
     * @description Нежелательный пациент.
     * @type {boolean}
     */
    isUnwanted: ({ labels }) => !!labels.find((item) => item.id === 'unwanted'),
    /**
     * @description Не звонить.
     * @type {boolean}
     */
    isNotCall: ({ labels }) => !!labels.find((item) => item.id === 'no-call'),
    /**
     * @description Список черт.
     * @type {{id:string,name:string}[]}
     */
    labelList: ({ labels, $options }) => labels
      .filter((item) => !$options.excludeLabels.includes(item.id)),
  },
  excludeLabels: ['black-list', 'unwanted', 'no-call'],
  props: {
    /**
     * @description Черты пациента.
     * @type {{id:string, name:string}[]}
     */
    labels: { required: true, type: Array },
  },
  titleBlackList: 'В черном списке',
  titleUnwanted: 'Проблемный пациент',
  titleNotCall: 'Не звонить',
};
</script>

<style lang="scss" scoped>
.patient-labels {
  display: flex;
  flex-flow: row wrap;
  gap: 8px;
  margin: 5px 0 0 0;
  &__item {
    background-color: #0489e024;
    border-radius: 24px;
    color: var(--action-color);
    cursor: default;
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    padding: 0 8px 2px 8px;
    white-space: nowrap;
  }
}
</style>
